import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getAirwaySelector } from '../selectors'
import { AirwayConstants } from '../store/airway.constants'
import { IAirwayState } from '../store/airway.types'

export function* setAirwayVerificationMethod() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const airwayState: IAirwayState = yield select(getAirwaySelector)
  const { inputRows } = procedureState
  const { verificationMethod } = airwayState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === AirwayConstants.SET_VERIFICATION_METHOD) {
        //@ts-ignore
        input.props.savedValues = verificationMethod
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setAirwayVerificationMethodSaga() {
  yield takeLatest([AirwayConstants.SET_VERIFICATION_METHOD], setAirwayVerificationMethod)
}
